import React, { useEffect, useState } from 'react'

// bootstrap
import { Container } from 'react-bootstrap'

// react redux
import { connect } from 'react-redux'

// toast
import { toast } from 'react-toastify'

// actions
import { setGlobalLoading } from 'redux/actions/actionCommon'

// API
import {
    deleteShipping,
    editShipping,
    getShippings
} from 'utlis/Apis/Shipping_API'

// app messages
import {
    UNKNOWN_ERROR_OCCURED,
    SHIPPING_DELETED_SUCCESSFULLY,
    getError,
    CONFIRMATION_BEFORE_DELETING_SHIPPING,
    ERROR_WHILE_DELETING_SHIPPING,
    ERROR_WHILE_FETCHING_SHIPPINGS,
    SHIPPING_UPDATED_SUCCESSFULLY,
    ERROR_WHILE_CREATING_SHIPPING,
    ERROR_WHILE__NAME
} from 'utlis/AppMessages/AppMessages'
import useStoreUrl from 'utlis/CustomHooks/useStoreUrl'


// helpers functions
import {
    conditionalShippingParams, customRateShippingParams, flatRateShippingParams, deleteExtra, freeShippingParams
} from './Pages/Shippings/Includes/Shipping/AddShipping/Helper'

// includes
import ShippingView from './Pages/Shippings/Includes/ShippingView'

// styles
import "./styles/shipping-styles.scss"

function Shippings(props) {
    // props
    const { authState } = props

    const [loading, setLoading] = useState(true)
    const [shippings, setShippings] = useState([])

    // store url
    const [storeUrl] = useStoreUrl()

    useEffect(() => {
        setLoading(true)
        const headers = {
            "Authorization": `Bearer ${authState.commonToken}`,
            "Api-Token": authState.apiToken,
            "Access-Token": "",
            // "Store-Id": authState.storeId,
        }
        getShippings(headers).then(res => {
            setLoading(false)
            const resData = res.data
            window.scrollTo(0, 0)
            if (resData && resData.success) {
                setShippings(resData.data)
            }
            if (resData && resData.error) {
                toast.dismiss();

                toast.error(getError(resData.message, ERROR_WHILE_FETCHING_SHIPPINGS), {
                    autoClose: 3000
                })
            }
        })
            .catch(resData => {
                console.log(`${getError(resData.message)} getShipping`)
                toast.dismiss();

                toast.error(getError(resData?.message, ERROR_WHILE_FETCHING_SHIPPINGS), {
                    autoClose: 2500,
                    onClose: () => {
                        setLoading(false)
                    }
                })
            })
    }, [authState, props])

    const deleteShipping_ = (id) => {
        var confirmation = window.confirm(CONFIRMATION_BEFORE_DELETING_SHIPPING)
        if (confirmation) {
            // setSectionLoadingVisible(true)
            setShippings(arr => [])
            const filterShippingList = shippings.filter(item => item.id !== id)
            setShippings(arr => [...filterShippingList])

            const headers = {
                "Authorization": `Bearer ${authState.commonToken}`,
                "Api-Token": authState.apiToken,
                "Access-Token": "",
                // "Store-Id": authState.storeId,
            }
            deleteShipping(headers, id).then(res => {
                // setSectionLoadingVisible(false)
                const deletedData = res.data
                if (deletedData.success) {
                    toast.dismiss();
                    toast.success(SHIPPING_DELETED_SUCCESSFULLY, {
                        autoClose: 2500,
                    })
                }

                if (deletedData.error) {
                    console.log(ERROR_WHILE_DELETING_SHIPPING, res)
                    toast.dismiss();

                    toast.error(ERROR_WHILE_DELETING_SHIPPING, {
                        autoClose: 2500,
                        onClose: () => {
                        }
                    })
                }

            }).catch(err => {
                console.log(`${ERROR_WHILE__NAME} deleteShipping `, err.message)
                toast.dismiss();
                toast.error(UNKNOWN_ERROR_OCCURED, {
                    autoClose: 2500,
                    onClose: () => {
                        // setSectionLoadingVisible(false)
                    }
                })
            })
        }
    }
    const addShipping_ = (shippings_) => {
        let params = {}
        if (shippings_.shipping_type === "free_shipping") {
            params = freeShippingParams(shippings_)
        } else if (shippings_.shipping_type === "conditional_free_shipping") {
            params = conditionalShippingParams(shippings_)
        } else if (shippings_.shipping_type === "flat_rate") {
            params = flatRateShippingParams(shippings_)
        } else {
            params = customRateShippingParams(shippings_)
        }
        params = deleteExtra(params)
        const headers = {
            "Authorization": `Bearer ${authState.commonToken}`,
            "Api-Token": authState.apiToken,
            "Access-Token": "",
            // "Store-Id": authState.storeId,
        }
        editShipping(headers, params).then(res => {
            setGlobalLoading(false)
            const shippingData = res.data
            if (shippingData.success) {
                // window.scrollTo(0, 0)
                toast.dismiss();
                // props.history.push(storeUrl + '/my-sales/sale-orders', {
                //     shouldReload: true
                // })
                toast.success(SHIPPING_UPDATED_SUCCESSFULLY, {
                    autoClose: 2000,
                    onClose: () => { }
                })
            }
            if (shippingData.error) {
                console.log(ERROR_WHILE_CREATING_SHIPPING, res)
                toast.dismiss();
                toast.error(getError(shippingData.message, ERROR_WHILE_CREATING_SHIPPING), {
                    autoClose: 3000,
                })
            }
        }).catch(err => {
            console.log(`${ERROR_WHILE__NAME} editShipping `, err.message)
            toast.dismiss();
            toast.error(UNKNOWN_ERROR_OCCURED, {
                autoClose: 2500,
                onClose: () => {
                    setGlobalLoading(false)
                }
            })
        })
    }
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [props])

    return (
        <section id="app-shipping" className="st-def-mar-TB page-eorc-wrapper mb-0">
            <Container fluid className="st-container">
                <div className="app-product-filters mb-0">

                    {/* header */}
                    <div className="app-header-wrapper mb-3">
                        <p className="app-heading text-capitalize">Shipping, Delivery, and Pickup</p>
                    </div>

                    {/* main view */}
                    <ShippingView
                        loading={loading}
                        shippings={shippings}
                        addShipping_={addShipping_}
                        deleteShipping={(id) => deleteShipping_(id)}
                    />
                </div>
            </Container>
        </section>
    )
}


const getDataFromStore = state => {
    return {
        authState: state.auth,
        sideBarVisibility: state.common.sideBarVisibility
    };
}

const dispatchActionsToProps = dispatch => {
    return {
        setGlobalLoading: bool => dispatch(setGlobalLoading(bool)),
    }
}

export default connect(getDataFromStore, dispatchActionsToProps)(Shippings)